// Copyright (c) StrangeBee 2024

import { createContext } from 'react';

export type CollapseContextInterface = {
    collapsed: boolean;
    setCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
    hasSider: boolean;
    setHasSider: React.Dispatch<React.SetStateAction<boolean>>;
};

// eslint-disable-next-line
export const CollapseContext = createContext<CollapseContextInterface>(undefined!);
